module.exports = __webpack_public_path__ + "static/media/equipment.7964610d.jpg";